import classNames from 'classnames'
import React from 'react'
import Container from './container'
import Grid from './grid'
import Link from './link'

export default function CtaSimple({ content, design }) {
  const { heading, description, link } = content ?? {}
  const { theme } = design ?? {}

  return (
    <section
      className={classNames(
        'standard-spacing',
        { dark: 'bg-secondary text-primary', light: 'bg-primary text-secondary' }[theme]
      )}>
      <Container>
        <Grid>
          <div className="col-span-12 md:col-start-2 md:col-span-10 lg:col-start-1 lg:col-span-6 xl:col-span-5">
            {heading && <h2 className="heading-3xl">{heading}</h2>}
            {description && <p className="mt-4 body-lg">{description}</p>}
          </div>
          {link && (
            <div className="col-span-12 md:col-start-2 lg:justify-self-end md:col-span-10 lg:col-span-6 xl:col-span-7">
              <Link
                className={classNames(
                  'mt-8 group border-2 rounded-[50%] inline-flex flex-col items-center justify-center w-[255px] h-[134px] md:w-[420px] md:h-[200px]',
                  { dark: 'dark-link', light: 'light-link' }[theme]
                )}
                {...link}>
                <span className="inline-block control-2xl">{link.title}</span>
                <span className="inline-block control-3xl group-hover:translate-x-3 transition duration-150 ease-[cubic-bezier(.47,.27,.28,.86)]">
                  <svg viewBox="0 0 63.8 49.4" className="mt-2 w-8 lg:w-11">
                    <path d="m26.2 42.5 32.3-16.8L0 29.1v-8.8l58.3 3.3L26.2 6.9 30.6 0l33.2 24.7-33.2 24.7-4.4-6.9Z" />
                  </svg>
                </span>
              </Link>
            </div>
          )}
        </Grid>
      </Container>
    </section>
  )
}
